
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[id]/news-articles/[[...page]]",
      function () {
        return require("private-next-pages/category/[id]/news-articles/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[id]/news-articles/[[...page]]"])
      });
    }
  